import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {makeGetViewerState} from '../../../../srcCommon/inboxes/side/sidePanelSelectors';
import {AppState} from '../../../store/appState';
import {getSideFrameIntegrations} from '../../../store/data/dataSelectors';
import {makeGetApplicationsPanel} from '../../../store/panels/applications/applicationPanelSelector';
import {
  makeGetAllOrNoSelectedConversations,
  makeGetConversationSelection,
  makeGetOnlySelectedConversation,
} from '../../../store/panels/cells/selectors/cellsPanelSelectionSelectors';
import {getCellsPanel, getViewerPanel} from '../../../store/panels/panelsSelectors';
import {ApplicationsPanelId} from '../../../store/panels/panelStateBase';
import {
  makeGetContentPage,
  makeGetViewerPanel,
  ViewerPanelPageSelector,
} from '../../../store/panels/viewer/viewerPanelSelectors';
import {getSidePanelFramesWithManager} from '../../../store/stateless/sidePanelFrameSelectors';
import {PopupApplication} from './popupApplication';

/*
 * Props.
 */

interface PopupApplicationContainerProps {
  panelId: ApplicationsPanelId;
}

/*
 * Selectors.
 */

const getViewerPanelId = createSelector([getViewerPanel], (panel) => {
  if (!panel) {
    throw new Error('Viewer panel is not defined.');
  }
  return panel.id;
});

const getCellsPanelId = createSelector([getCellsPanel], (panel) => {
  if (!panel) {
    throw new Error('Cells panel is not defined.');
  }
  return panel.id;
});

function makeGetViewerConversationSelection<P>(getViewerPage: ViewerPanelPageSelector<P>) {
  const getViewerParameters = (state: AppState, props: P) => {
    const {parameters} = getViewerPage(state, props);
    return parameters;
  };

  return makeGetConversationSelection(getViewerParameters, getCellsPanelId);
}

function makeGetCellsContext<P>(getViewerPage: ViewerPanelPageSelector<P>) {
  return (state: AppState, props: P) => {
    const {cellsContext} = getViewerPage(state, props);
    return cellsContext;
  };
}

const getHasIntegrationFrames = createSelector(
  [getSideFrameIntegrations],
  (integrations) => integrations.length > 0,
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<PopupApplicationContainerProps>()(() => {
  const getViewerPanelSelector = makeGetViewerPanel(getViewerPanelId);
  const getViewerPage = makeGetContentPage(getViewerPanelSelector);
  const getConversationSelection = makeGetViewerConversationSelection(getViewerPage);

  return {
    applicationsPanel: makeGetApplicationsPanel(),
    viewerPanelId: getViewerPanelId,
    frames: getSidePanelFramesWithManager,
    hasIntegrationFrames: getHasIntegrationFrames,
    viewerState: makeGetViewerState(getViewerPage),
    onlyConversation: makeGetOnlySelectedConversation(getConversationSelection),
    selectedConversations: makeGetAllOrNoSelectedConversations(getConversationSelection, getCellsPanelId),
    cellsContext: makeGetCellsContext(getViewerPage),
  };
});
export const PopupApplicationContainer = connect(mapStateToProps)(PopupApplication);
